module.exports = __webpack_public_path__ + "img/link-2.0321b9b8.png";